var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 15,
  fill: "none",
  viewBox: "0 0 20 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18.998.151a.6.6 0 0 1 .051.847l-11.52 13a.6.6 0 0 1-.851.047l-6.48-5.85a.6.6 0 0 1 .804-.89l6.03 5.444L18.152.202a.6.6 0 0 1 .847-.051",
  clipRule: "evenodd"
})));
export { SvgIconCheck as ReactComponent };